import React from 'react';
import { compose } from 'ramda';
import classnames from 'classnames/bind';

import styleFile from './radioGroupField.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withForm } from './';
import RichText from '@synergycms_core/components/generic/RichText';

export default compose(
  withForm(),
  PropertyManager([
    'form',
    'formModel',
    'validations',
    'model',
    'css',
    'validationsFields',
    'defaultValue',
    'name',
    'options'
  ]),
  withThemeJSS({ styleFile,link:true })
)(
  class RadioGroupField extends React.Component {
    static displayName = 'RadioGroupField';
    constructor(props) {
      super(props);

      const { form, model, defaultValue = false, validations = [], validationsFields } = this.props.config;

      form.subscribe({
        model: model,
        onChange: this.onChange,
        forceUpdate: this.forceUpdate,
        validations: validations,
        defaultValue: defaultValue,
        value: defaultValue,
        validationsFields: validationsFields
      });

      this.state = {
        value: defaultValue
      };
    }

    /*componentDidUpdate = () => {
      //this.subscribe();
    };*/

    componentDidMount = () => {};

    onChange = event => {
      const value = event && event.target.value;

      const { config } = this.props;
      const { form, formModel } = config;
      if (!formModel.visited) {
        form.updateModel(config.model, { visited: true });
      }
      this.setState({ value: value }, () => {
        const { config } = this.props;
        config.form.onGlobalChange(config.model, value).then(() => {
          config.form.onGlobalBlur(config.model);
        });
      });
    };

    render = () => {
      const { value } = this.state;
      const { theme, config } = this.props;
      const { form, formModel, model, css, options } = config;
      const {classes} = theme.styles;
      let cx = classnames.bind(styleFile);
      return (
        (formModel && (
          <div
            className={[
              form.getValidClass(formModel, css, theme),
              theme.computedInnerStyle,
              cx({ checked: value })
            ].join(' ')}>
            {options.map(option => (
              <span key={option.value} className={classes.radioButtonContainer}>
                <input
                  id={option.value}
                  onChange={this.onChange}
                  type="radio"
                  name={model}
                  value={option.value}
                  checked={value === option.value}
                />
                <label htmlFor={option.value}>
                  {' '}
                  <RichText
                    text={option.text}
                    translate={option.translate || false}
                    ucFirst={option.ucFirst || false}
                    innerStyle={option.innerStyle}
                  />
                </label>
              </span>
            ))}
          </div>
        )) ||
        null
      );
    };
  }
);
